(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('Commissione', Commissione);

    Commissione.$inject = ['$resource'];

    function Commissione ($resource) {
        var resourceUrl =  'api/:public/commissiones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', params: {public: 'public'}, isArray: true},
            'get': {
                method: 'GET',
                params: {public: 'public'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
